import { faClock, faHourglass } from '@fortawesome/pro-solid-svg-icons';
import type { ReactNode } from 'react';
import styled from 'styled-components';

import { FontAwesomeIcon } from '#src/atoms/icons/index.tsx';
import { BrandXS } from '#src/atoms/typography/index.tsx';
import { CornerBadge } from '#src/components/CornerBadge/index.tsx';

const TIME_GRADIENT =
  'linear-gradient(188deg, rgb(255, 255, 255) 1.37%, rgb(252, 255, 99) 36.66%, rgb(194, 105, 0) 101.57%)' as const;

const ICON_MAP = {
  date: faHourglass,
  countdown: faClock,
} as const;

const Root = styled.div`
  display: inline-flex;
`;
const Badge = styled.div`
  display: inline-flex;
  gap: var(--half-unit);
  padding: 2px var(--half-unit);
  border-radius: var(--half-unit);
  color: var(--c-black);
`;

type TimeLabelState = 'date' | 'countdown';
type TimeLabelType = 'banner' | 'badge';

type Props = {
  children: ReactNode;
  state: TimeLabelState;
  type?: TimeLabelType;
};

export const TimeLabel = ({ children, state, type = 'badge' }: Props) => {
  const content = (
    <>
      <FontAwesomeIcon icon={ICON_MAP[state]} />
      <BrandXS>{children}</BrandXS>
    </>
  );

  if (type === 'banner') {
    return (
      <Root>
        <CornerBadge color={TIME_GRADIENT}>{content}</CornerBadge>
      </Root>
    );
  }

  return (
    <Root>
      <Badge style={{ background: TIME_GRADIENT }}>{content}</Badge>
    </Root>
  );
};
